import i18n from '@/utils/i18n';
import store from 'store2';
import { create } from 'zustand';

/**
 * Types
 */
import type { ConfigProviderProps } from 'antd';

type ConfigStore = {
    config: ConfigProviderProps;
    locale: string;
    setConfig: (config: ConfigProviderProps) => void;
    setLocale: (locale: string) => void;
};

export const useConfigStore = create<ConfigStore>((set) => ({
    config: {},
    locale: store('i18nextLng') || 'zh',
    setConfig: (config) => set({ config }),
    setLocale: (locale) => {
        set({ locale });

        i18n.changeLanguage(locale);
    },
}));
